import { cn } from '@massilia/ui'

interface SummaryRowProps {
  highlight?: boolean
  label: string
  value?: string
}

export function SummaryRow({ highlight, label, value }: SummaryRowProps) {
  return (
    <div className="flex items-start justify-between gap-3 text-sm">
      <div className="font-medium text-gray-light-700">{label}</div>
      {/* `min-w-0` + `break-words` : une référence de dossier ou un nom long
          poussait la ligne au-delà de l'écran et faisait défiler la page
          entière de côté. */}
      <div
        className={cn(
          'min-w-0 text-right font-semibold break-words text-gray-light-900',
          highlight && value && 'text-brand-600'
        )}
      >
        {value ?? '-'}
      </div>
    </div>
  )
}
